import { FC, useMemo } from "react";

import { BoldText, FlexContainer, Icon, MutedText, SmallText } from "shared/styles";
import { AtIcon, Message } from "shared/assets/icons";
import { colors } from "shared/styles/constants";
import { IScheduleBlockEntry } from "Bands/types";
import { copy } from "shared/assets";
import { IStatus } from "shared/types";
import { ActionDropdown } from "shared/components";
import { MemberName, ScheduleBlockEntryTime } from "..";
import { StyledEntry, StyledEntryInfo } from "./styles";

interface ScheduleBlockEntryProps {
  entry: IScheduleBlockEntry;
  eventTimezone?: string;
  setShowEditEntryModal?: (entry: IScheduleBlockEntry) => void;
  setShowDeleteEntryModal: (entry: IScheduleBlockEntry) => void;
  index: number;
  showActions?: boolean;
}
export const ScheduleBlockEntry: FC<ScheduleBlockEntryProps> = ({
  entry,
  index,
  showActions,
  setShowEditEntryModal,
  setShowDeleteEntryModal,
}) => {
  const { title, description, users, ...rest } = entry;

  const actions = useMemo(
    () => [
      {
        label: copy.actions.edit,
        handleClick: () => setShowEditEntryModal && setShowEditEntryModal(entry),
        dataTestId: "edit_event_schedule_entry",
      },
      {
        label: copy.actions.delete,
        handleClick: () => setShowDeleteEntryModal(entry),
        dataTestId: "delete_event_schedule_entry",
        status: IStatus.error,
      },
    ],
    [entry, setShowDeleteEntryModal, setShowEditEntryModal]
  );

  return (
    <StyledEntry isStriped={index % 2 === 0}>
      <ScheduleBlockEntryTime {...rest} />
      <StyledEntryInfo>
        <BoldText as={SmallText}>{title}</BoldText>
        {!!users?.length && (
          <div>
            <FlexContainer flexWrap="nowrap" align="flex-start">
              <Icon as={AtIcon} color={colors.grey5} style={{ marginTop: "6px" }} />{" "}
              <span>
                {users?.map((user, index) => (
                  <SmallText as={MutedText} key={index}>
                    <MemberName user={user} />
                    {users?.length - 1 > index && ", "}
                  </SmallText>
                ))}
              </span>
            </FlexContainer>
          </div>
        )}
        {description && (
          <div>
            <FlexContainer flexWrap="nowrap" align="flex-start">
              <Icon as={Message} color={colors.grey5} style={{ marginTop: "6px" }} />
              <SmallText as={MutedText}>{description}</SmallText>
            </FlexContainer>
          </div>
        )}
      </StyledEntryInfo>
      {showActions && (
        <ActionDropdown
          options={actions}
          label={copy.actions.actions}
          placement="bottom-end"
          dataTestId="table_actions"
          wrapOptions
        />
      )}
    </StyledEntry>
  );
};
